import clsx from "clsx";
import { cva, type VariantProps } from "cva";
import { PropsWithChildren, type ReactNode } from "react";

import styles from "./index.module.css";

export const fontSizes = ["xxm", "xm", "m"] as const;
export const textAligns = ["left", "center"] as const;

export const variants = cva({
  base: styles.base,
  variants: {
    fontSize: {
      xxm: styles.title_xxm,
      xm: styles.title_xm,
      m: styles.title_m,
    },
    textAlign: {
      left: styles.text_align_left,
      center: styles.text_align_center,
    },
  },
  defaultVariants: {
    fontSize: "xxm",
    textAlign: "left",
  },
});

export type TitleProps = PropsWithChildren<
  VariantProps<typeof variants> & {
    id?: string;
    className?: string;
    /** アイコン */
    icon?: ReactNode;
    /** 見出しタグ */
    as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  }
>;

export const Title = ({ children, className, fontSize, textAlign, icon, as, id }: TitleProps) => {
  const Tag = as || "div";

  return (
    <Tag id={id} className={clsx(variants({ fontSize, textAlign }), styles.title, className)}>
      {icon && <span className="shrink-0">{icon}</span>}
      {children}
    </Tag>
  );
};
